
// Archivo generado automáticamente por el pipeline


export const API_URL='https://search.amxinfra.com/api/unotv/';
export const PATHURLDOMAIN='https://wwww.unotv.com/';
export const API_LOCAL='https://cdn.amxinfra.com/json/buscador/';
export const PAGESIZE=20;
export const MAX_RETRIES = 3; // Número máximo de reintentos
